<form [formGroup]="specBelastingBox3FormGroup">
    <div formGroupName="specificatieBelastingBox3">
        <div formGroupName="opbouw">
            <div
                    *ngIf="(this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.vrijstellingBuitenlandsVermogen !== undefined &&
                    this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.vrijstellingBuitenlandsVermogen! > 0) ||
                    (this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.verrekeningBuitenlandseBronheffing !== undefined &&
                    this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.verrekeningBuitenlandseBronheffing! > 0)">
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Belasting box 3 voor voorkoming: : {{ this.wetgevingFg.get("box3Percentage")?.value }}% van
                        € {{ this.berekeningFormGroup.get(['box3', 'belastbaarInkomen'])?.value | number: '1.0-0' }}
                    </div>
                    <div></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="box3VoorVoorkoming"
                                id="box3VoorVoorkoming"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
            <div
                    *ngIf="this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.vrijstellingBuitenlandsVermogen !== undefined &&  this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.vrijstellingBuitenlandsVermogen! > 0">
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Af: Vrijstelling i.v.m. buitenlands vermogen
                    </div>
                    <div></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="vrijstellingBuitenlandsVermogen"
                                id="vrijstellingBuitenlandsVermogen"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
            <div
                    *ngIf="this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.verrekeningBuitenlandseBronheffing !== undefined &&  this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.verrekeningBuitenlandseBronheffing! > 0">
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Af: Verrekening buitenlandse bronheffing
                    </div>
                    <div></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="verrekeningBuitenlandseBronheffing"
                                id="verrekeningBuitenlandseBronheffing"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
            <div *ngIf="(this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.berekendeIB !== undefined &&
            this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.berekendeIB! > 0) ||
            (this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.box3VoorVoorkoming !== undefined &&
            this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.box3VoorVoorkoming! > 0)">

                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        <div *ngIf="(this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.vrijstellingBuitenlandsVermogen === undefined ||
                        this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.vrijstellingBuitenlandsVermogen! === 0) &&
                        (this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.verrekeningBuitenlandseBronheffing === undefined ||
                        this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.verrekeningBuitenlandseBronheffing! === 0)">
                            <div class="flex-container-dialog">
                                Belasting box
                                3: {{ this.wetgevingFg.controls.box3Percentage?.getRawValue()! | number: '1.0-2' }}% van
                                € {{ this.berekening.box3?.belastbaarInkomen | number: '1.0-0' }}
                            </div>
                        </div>
                        <div *ngIf="(this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.vrijstellingBuitenlandsVermogen !== undefined &&
                    this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.vrijstellingBuitenlandsVermogen! > 0) ||
                    (this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.verrekeningBuitenlandseBronheffing !== undefined &&
                    this.specBelastingBox3.specificatieBelastingBox3?.opbouw?.verrekeningBuitenlandseBronheffing! > 0)">
                            <div class="flex-container-dialog">
                                Belasting box 3
                            </div>
                        </div>
                    </div>
                    <div class="flex-item-ruimte-dialog"></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="berekendeIB"
                                id="berekendeIB"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€"
                                placeholder="-"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

